<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"><span class="t2">Dance Until the World Ends</span></p>
<p class="p0">By Davina Lee</p>
<p class="p2"><a id="a3"></a><a href="#/005#a18">Chapter 1: Lina and Arabel</a></p>
<p class="p2"><span href="#/006#a19" title="Link target outside of Sample">Chapter 2: The Rave</span></p>
<p class="p2"><span href="#/007#a20" title="Link target outside of Sample">Chapter 3: Cloud Sailing</span></p>
<p class="p2"><span href="#/008#a21" title="Link target outside of Sample">Chapter 4: The Queen’s Gala</span></p>
<p class="p2"><span href="#/009#a22" title="Link target outside of Sample">Chapter 5: Island of the Missing</span></p>
<p class="p2"><span href="#/010#a23" title="Link target outside of Sample">Chapter 6: Island of the Drones</span></p>
<p class="p2"><span href="#/011#a24" title="Link target outside of Sample">Chapter 7: Into the Abyss</span></p>
<p class="p2"><span href="#/012#a25" title="Link target outside of Sample">Chapter 8: The Land of Milk and Honey</span></p>
<p class="p2"><span href="#/013#a26" title="Link target outside of Sample">Chapter 9: Rave On</span></p>
<p class="p2"><span href="#/014#a27" title="Link target outside of Sample">Chapter 10: The Island of Home</span></p>
<p class="p2"><span href="#/015#a28" title="Link target outside of Sample">Chapter 11: Coronation Day</span></p>
<p class="p2"><span href="#/016#a29" title="Link target outside of Sample">Epilogue</span></p>
<p class="p2"><span href="#/017#a30" title="Link target outside of Sample">Afterword: The World of Lina and Arabel</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?09016920